<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="red">
            <h4 class="title">Donor Search</h4>
            <p class="category">List of all the donors</p>
          </md-card-header>
          <md-card-content>
            <!--<donor-search-table table-header-color="green"></donor-search-table>-->
            <div table-header-color="green">
              <md-table v-model="donorsList" :table-header-color="tableHeaderColor">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Name">{{ item.partial_user.name }}</md-table-cell>
                  <md-table-cell md-label="Phone">{{ item.partial_user.phone_number }}</md-table-cell>
                  <md-table-cell md-label="Blood Group">{{ item.blood_group.blood_group }}</md-table-cell>
                  <md-table-cell md-label="Gender">{{ item.gender.gender }}</md-table-cell>
                  <md-table-cell md-label="Action"><button class="sendRequest"><span>Send Request</span></button></md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
  var moment = require('moment');

  export default{
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        selected: [],
        donorsList: []
      }
    },
    beforeMount: function () {
      this.donorsList = JSON.parse(localStorage.getItem('donor_sorting_list'))
      console.log(this.donorsList)
    }
  }
</script>
<style scoped>
  .sendRequest {
    border-radius: 4px;
    background-color: #4caf50 !important;
    padding: 5px;
    width: auto;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    margin: 5px;
    margin-right: 10px;

  }
</style>
